// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__xFtTO","blur":"styles_blur__wzFNv","loader":"styles_loader__Az0dD","display_loader":"styles_display_loader__m12P5"};